import React, { useEffect, useRef } from 'react'
import { func, object, bool } from 'prop-types'
import { Field } from 'formik'
import Input from 'components/Input'
import Dropdown from 'components/Dropdown'
import FieldsetItem from 'components/Fieldset/FieldsetItem'
import { CANADIAN_PROVINCES } from 'utils/constants'
import { isValid, isPostalCodeValid } from 'utils/validators'

const validateFilled = value => {
  if (!isValid(value)) return 'Required'
}

const ManualAddressFieldset = ({ values, setFieldValue, isFloating, allowedProvinces }) => {
  const addressRef = useRef()
  const validatePostalCode = value => {
    if (!isValid(value)) return 'Required'
    if (!isPostalCodeValid(values)) return 'Invalid postal code'
  }
  useEffect(() => {
    addressRef.current.focus()
    return () => setFieldValue('isManualEntry', false)
  }, [setFieldValue])

  useEffect(() => {
    if (!values.country) setFieldValue('country', 'Canada')
  }, [values?.country, setFieldValue])

  useEffect(() => {
    setFieldValue('postalCode', values?.postalCode?.toUpperCase())
  }, [values?.postalCode, setFieldValue])

  return (
    <>
      <FieldsetItem xs="1-1">
        <Field name="street" validate={validateFilled}>
          {({ field, form: { errors, touched } }) => (
            <Input
              ref={addressRef}
              placeholder="123 Main St"
              label="Street Address"
              type="text"
              {...field}
              meta={{
                error: errors.street,
                touched: touched.street
              }}
              isFloating={isFloating}
            />
          )}
        </Field>
      </FieldsetItem>
      <FieldsetItem xs="1-1">
        <Field name="subBuilding">
          {({ field, form: { errors, touched } }) => (
            <Input
              label="Apartment, suite, etc. (optional)"
              placeholder="Apt 2"
              type="text"
              {...field}
              meta={{
                error: errors.subBuilding,
                touched: touched.subBuilding
              }}
              isFloating={isFloating}
            />
          )}
        </Field>
      </FieldsetItem>

      <FieldsetItem xs="1-1" sm="1-2">
        <Field name="city" validate={validateFilled}>
          {({ field, form: { errors, touched } }) => (
            <Input
              label="City"
              placeholder="Atlantis"
              type="text"
              {...field}
              meta={{
                error: errors.city,
                touched: touched.city
              }}
              isFloating={isFloating}
            />
          )}
        </Field>
      </FieldsetItem>

      <FieldsetItem xs="1-1" sm="1-2">
        <Field name="postalCode" validate={validatePostalCode}>
          {({ field, form: { errors, touched } }) => (
            <Input
              label="Postal Code"
              placeholder="A1A A1A"
              type="text"
              {...field}
              meta={{
                error: errors.postalCode,
                touched: touched.postalCode
              }}
              isFloating={isFloating}
            />
          )}
        </Field>
      </FieldsetItem>
      <FieldsetItem xs="1-1" sm="1-2">
        <Field name="province" validate={validateFilled}>
          {({ field, form: { errors, touched } }) => (
            <Dropdown
              label="Province"
              placeholder="Select..."
              options={
                allowedProvinces
                  ? CANADIAN_PROVINCES.filter(({ value }) => allowedProvinces.includes(value))
                  : CANADIAN_PROVINCES
              }
              {...field}
              meta={{
                error: errors.province,
                touched: touched.province
              }}
              isFloating={isFloating}
              full
              disabled={allowedProvinces.length === 1}
            />
          )}
        </Field>
      </FieldsetItem>

      <FieldsetItem xs="1-1" sm="1-2">
        <Input label="Country" name="country" type="text" value="Canada" disabled isFloating={isFloating} />
      </FieldsetItem>
    </>
  )
}

ManualAddressFieldset.propTypes = {
  values: object,
  setFieldValue: func,
  setFieldError: func,
  isFloating: bool
}

export default ManualAddressFieldset
